import {PROJECT_OLSZTYN} from '../../constants';
import './footer.scss';
import template from './footer.html';

class FooterComponent {
  /** @ngInject */
  constructor() {
    this.PROJECT_OLSZTYN = PROJECT_OLSZTYN;
  }
}

export const Footer = {
  bindings: {
    user: '<'
  },
  template,
  controller: FooterComponent
};
